import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            内容分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            六大精选频道，覆盖欧美影视、音乐、综艺、纪录片、时尚与体育，满足您对欧美一区的全方位探索需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-white rounded-lg p-6 md:p-7 hover:bg-background-100 transition-all duration-300 cursor-pointer border border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100/70 group-hover:bg-primary-200/70 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-xl text-primary-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all flex-shrink-0 self-center">
                  <i className="ri-arrow-right-line text-lg"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}